import { View } from 'foundations-components/components/View';
import { useCallback } from 'react';
import { TeamPaddingWrapper } from '../../shared/components/TeamPaddingWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const checkIsTeamOption = option => !!option.dropdownStyle;
export const useSelectItemComponentShim = itemComponent => useCallback(props => {
  const {
    option
  } = props;
  const Component = itemComponent !== null && itemComponent !== void 0 ? itemComponent : View;
  let fullProps = props;
  if (checkIsTeamOption(option)) {
    var _option$paddingInline;
    const [paddingInlineStart, ...otherPadding] = (_option$paddingInline = option.paddingInlineStart) !== null && _option$paddingInline !== void 0 ? _option$paddingInline : [];
    fullProps = Object.assign({
      style: option.dropdownStyle
    }, props, {
      children: /*#__PURE__*/_jsx(TeamPaddingWrapper, {
        paddingInlineStart: otherPadding,
        children: props.children
      }),
      paddingInlineStart
    });
  }
  return /*#__PURE__*/_jsx(Component, Object.assign({}, fullProps));
}, [itemComponent]);